import Timeline from "@mui/lab/Timeline";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import ExperienceEntry from "../components/ExperienceEntry";
import SectionHeader from "../components/SectionHeader";
import Seo from "../components/Seo";
import { experienceItems } from "../content";
import { breadcrumbSchema } from "../lib/structuredData";

const timelineTheme = createTheme({
  palette: { mode: "dark" },
  typography: { fontFamily: '"Geist", sans-serif' },
});

function ExperiencePage() {
  return (
    <section id="experience">
      <Seo
        description="Robert Doe's professional experience: research and teaching assistant roles at Arizona State University, full-stack development internships, and work at KNUST, Ghana."
        jsonLd={breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Experience", path: "/experience" }])}
        path="/experience"
        title="Experience - Robert Doe"
      />
      <SectionHeader number="03" title="Experience" />
      <ThemeProvider theme={timelineTheme}>
        <Timeline sx={{ m: 0, p: 0 }}>
          {experienceItems.map((item, index) => (
            <TimelineItem key={`${item.role}-${item.date}`}>
              <TimelineOppositeContent sx={{ flex: 0, padding: 0 }} />
              <TimelineSeparator>
                <TimelineDot sx={{ bgcolor: "#b3862c", boxShadow: "none", m: 0 }} />
                {index < experienceItems.length - 1 ? (
                  <TimelineConnector sx={{ bgcolor: "rgba(255, 255, 255, 0.16)" }} />
                ) : null}
              </TimelineSeparator>
              <TimelineContent className="reveal" sx={{ pb: 4, pt: 0, minWidth: 0 }}>
                <ExperienceEntry item={item} />
              </TimelineContent>
            </TimelineItem>
          ))}
        </Timeline>
      </ThemeProvider>
    </section>
  );
}

export default ExperiencePage;
